import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { UserCommunicationSetting } from './accounts.types';

export interface SharedUser {
  id: string | number | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  user_id?: string | number | null;
  principal_user_id?: string | number | null;
  team_members?: Array<{ account_user_email?: string }> | null;
  user_info?: SharedUserInfo | null;
  communication_channel_value?: number | null;
  user_communication_settings?: UserCommunicationSetting[] | null;
}

// Minimal shared shape for user_info across apps
export interface SharedUserInfo {
  login?: { last_login?: string | null } | null;
  preferences?: {
    sms_communication?: { sms_opt_in?: boolean | null } | null;
    email_communication?: {
      email_address?: string | null;
      own_notification?: {
        send_to?: Array<{ label: string; value: string }> | null;
        selected_email?: string | null;
      } | null;
      qr_account_summary?: { selected_day?: string | null; send_notifications?: boolean | null } | null;
      send_notifications?: boolean | null;
      client_notifications?: { options?: Record<string, unknown> | null } | null;
      renewal_notifications?: { frequency?: number | null; send_notifications?: boolean | null } | null;
    } | null;
    old_data_management?: { limit?: number | null; stop_notification?: boolean | null } | null;
    phone_communication?: {
      phone_number?: string | null;
      notifications?: {
        call_when_quote_ready?: boolean | null;
        text_when_quote_ready?: boolean | null;
        text_when_bond_rider_ready?: boolean | null;
      } | null;
    } | null;
    preferred_communication?: string | null;
  } | null;
}

export interface SharedUserService<TUserInfo = SharedUserInfo> {
  get(): Observable<(SharedUser & { user_info?: TUserInfo | null }) | null>;
  current?: Signal<(SharedUser & { user_info?: TUserInfo | null }) | null>;
}

export const CURRENT_USER_TOKEN = new InjectionToken<SharedUserService<any>>('CURRENT_USER_TOKEN');


